import {useLocation} from "react-router-dom";

export const useIsPolishOnlyPath = () => {
    const POLISH_ONLY_PATHS = ["publikacje", "newshub", "biuro-prasowe"];
    const {pathname} = useLocation();

    return POLISH_ONLY_PATHS.some((path) => pathname.includes(path));
};
